import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import showDiv from '@ivy/fts/showDiv';
import realGroup from '../../comps/realGroup.vue';
import SellDetail from '../../comps/sellDetail.vue';
let SnapshotAct = class SnapshotAct extends Vue {
    constructor() {
        super(...arguments);
        this.show = false;
    }
    mounted() {
        const msec = new Date(this.snapshotInfo.activity.end_time
            ? this.snapshotInfo.activity.end_time.replace(/-/g, '/')
            : this.snapshotInfo.activity.presell_end_time.replace(/-/g, '/')).getTime() -
            new Date(this.snapshotInfo.create_time.replace(/-/g, '/')).getTime();
        if (msec <= 0)
            return;
        this.snapshotTime = Date.formatMs(msec, 'DD hh mm ss');
        this.show = true;
    }
    getPriceClass(type) {
        switch (type) {
            case 'limit_buy':
                return `limit_buy`;
            case 'group':
                return `group`;
            case 'presell':
                return `presell`;
            case 'limit_free':
                return `limit_free`;
        }
    }
    showRule() {
        this.$router.push({
            path: `/presellRule`,
            query: {
                ruleUrl: this.snapshotInfo.activity.rule_pic,
            },
        });
    }
    async showQr() {
        await showDiv(realGroup, {
            info: {
                qrcode: this.snapshotInfo.activity.front_official_account_qrcode ||
                    this.snapshotInfo.activity.qrcode,
            },
        });
    }
};
tslib_1.__decorate([
    Prop()
], SnapshotAct.prototype, "activity", void 0);
tslib_1.__decorate([
    Prop()
], SnapshotAct.prototype, "create_time", void 0);
tslib_1.__decorate([
    Prop()
], SnapshotAct.prototype, "snapshotInfo", void 0);
SnapshotAct = tslib_1.__decorate([
    Component({
        components: {
            SellDetail,
        },
    })
], SnapshotAct);
export default SnapshotAct;
